import { defineMessages } from 'react-intl';
import type { IntlShape, MessageDescriptor, PrimitiveType } from 'react-intl';

export const errorMessage = defineMessages({
    quantityNotAvailable: {
        id: 'quantity.not-available',
        defaultMessage: '{quantityInBag} items in bag, only {quantityAvailable} available',
    },
    quantityMaximumAvailable: {
        id: 'quantity.maximum-available',
        defaultMessage: 'Bag contains maximum available quantity.',
    },
});

export enum UIErrorCode {
    'QUANTITY_NOT_AVAILABLE' = 1001,
    'MAXIMUM_AVAILABLE_QUANTITY' = 1002,
    'EXTEND_ITEMS_EXCEED_ASSOCIATED_ITEM_QUANTITY' = 1003,
}

export const UI_ERRORS = new Map<UIErrorCode, MessageDescriptor>([
    [UIErrorCode.QUANTITY_NOT_AVAILABLE, errorMessage.quantityNotAvailable],
    [UIErrorCode.MAXIMUM_AVAILABLE_QUANTITY, errorMessage.quantityMaximumAvailable],
]);

export const getLocalizedErrorMessage = (
    intl: IntlShape,
    errorCode: UIErrorCode,
    values?: Record<string, PrimitiveType | undefined>,
): string => {
    if (!UI_ERRORS.has(errorCode)) {
        return '';
    }
    const messageDescriptor = UI_ERRORS.get(errorCode);
    return messageDescriptor ? intl.formatMessage(messageDescriptor, values) : '';
};
